var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"62px"},attrs:{"id":"app"}},[_c('Navbar',{staticStyle:{"z-index":"1000","width":"100%"}}),_c('router-view'),_c('Footer'),_c('Alert')],1)}
var staticRenderFns = []

export { render, staticRenderFns }